.addresses {
    max-height: 250px;
    overflow-y: auto;
}
